module.exports = __webpack_public_path__ + "static/media/canada5.ae5d1adf.jpg";